import { render, staticRenderFns } from "./error-list.vue?vue&type=template&id=f54579ba&scoped=true"
import script from "./error-list.vue?vue&type=script&lang=js"
export * from "./error-list.vue?vue&type=script&lang=js"
import style0 from "./error-list.vue?vue&type=style&index=0&id=f54579ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54579ba",
  null
  
)

export default component.exports